import {FC, createContext, useContext, useState, PropsWithChildren} from 'react'
import {initialQueryState, QueryState} from './_models'

export interface QueryRequestContextProps {
  state: QueryState
  updateState: (updates: Partial<QueryState>) => void
}

const QueryRequestContext = createContext<QueryRequestContextProps>({
  state: initialQueryState,
  updateState: () => {},
})

const QueryRequestProvider: FC<PropsWithChildren<{}>> = ({children}) => {
  const [state, setState] = useState<QueryState>(initialQueryState)

  const updateState = (updates: Partial<QueryState>) => {
    setState((prevState) => ({
      ...prevState,
      ...updates,
    }))
  }

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)

export {QueryRequestProvider, useQueryRequest} 